import { Loader, Text } from "@mantine/core";

export const ImageLoading = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 1)",
        zIndex: 20,
        // aspectRatio: "1/1",
      }}
    >
      <div style={{ height: "100%", paddingTop: 200 }}>
        <div style={{ textAlign: "center" }}>
          <Loader size="md" color="blue" />
          <Text size="sm" color="dimmed" mt="xs">
            Loading image...
          </Text>
        </div>
      </div>
    </div>
  );
};
